import {
  ChartSquareBarIcon,
  CalculatorIcon,
} from "@heroicons/react/solid";
import { NavigationTypes } from "./types";

function today() {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date.toISOString().slice(0, 10);
}

export const navigation: NavigationTypes[] = [
  {
    name: "Metrics",
    href: "/metrics",
    module: "metrics",
    icon: ChartSquareBarIcon,
  },
  {
    name: "Count Status",
    href: `/count?startDate=${today()}&endDate=${today()}&countStatus=All Status`,
    module: "count",
    icon: CalculatorIcon,
  },
];
